import { FC } from 'react';
import { Link as ReactLink } from 'react-router-dom';
import { Box, HStack, Link, Text } from '@chakra-ui/react';

import styles from './HeaderLogo.module.scss';
import { getDataTracking } from '../../../utils';

export interface HeaderLogoProps {
  programName?: string;
}

export const HeaderLogo: FC<HeaderLogoProps> = ({
  programName = 'Fundraising',
}) => (
  <Link
    {...getDataTracking(`header-${programName}-logo`)}
    to="/"
    as={ReactLink}
    textDecoration="none"
    _hover={{ textDecoration: 'none' }}
  >
    <HStack>
      <Box className={styles.sjLogo} w={['4.0rem', '5.5rem']} />
      <Box fontSize={['md', 'xl']} color="brand.primary.swatch1">
        <Text fontWeight="800" lineHeight="1">
          St. Jude
        </Text>
        <Text fontWeight="400">{programName}</Text>
      </Box>
    </HStack>
  </Link>
);
